import { useState, useEffect } from 'react';

const useLocation = () => {
  const [locationId, setLocationId] = useState(() => {
    return localStorage.getItem('location_id') || "all"; 
  });

  useEffect(() => {
    const handleStorageChange = () => {
      const updatedId = localStorage.getItem('location_id');
      if (updatedId !== locationId) {
        setLocationId(updatedId);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [locationId]);

  return locationId;
};

export default useLocation;